// NotificationContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { socket } from "./socket";
import axios from "axios";
import axiosInstance from "../axios/axiosInstance";
import "./NotificationSystem.css";

const NotificationContext = createContext();

export const NotificationProvider = ({ token, userRole, children }) => {
  const [notifications, setNotifications] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showAllPage, setShowAllPage] = useState(false);

  const unreadCount = notifications.filter((n) => !n.is_read).length;

  const fetchNotifications = async () => {
    try {
      const res = await axiosInstance.get("/api/admin/list-notifications");
      console.log("Notifications:", res.data);
      setNotifications(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const markAsRead = async (id) => {
    try {
      await axiosInstance.put(`/api/admin/notification/mark-as-read/${id}`);
      setNotifications((prev) =>
        prev.map((n) => (n.id === id ? { ...n, is_read: true } : n))
      );
    } catch (err) {
      console.error(err);
    }
  };

  const markAllAsRead = async () => {
    // Get all unread notifications
    const unreadNotifications = notifications.filter((n) => !n.is_read);

    try {
      // Send API requests for each unread notification
      await Promise.all(
        unreadNotifications.map((n) =>
          axiosInstance.put(`/api/admin/notification/mark-as-read/${n.id}`)
        )
      );

      // Update local state
      setNotifications((prev) => prev.map((n) => ({ ...n, is_read: true })));
    } catch (err) {
      console.error("Failed to mark some notifications as read:", err);
    }
  };

  useEffect(() => {
    if (!token) return;
    fetchNotifications();
    socket.connect();
    socket.emit("register", userRole);

    socket.on("notification", (notification) => {
      const normalized = {
        ...notification,
        is_read:
          notification.is_read === 0 ||
            notification.is_read === false ||
            notification.is_read === "0"
            ? 0
            : 1,
      };

      setNotifications((prev) => [normalized, ...prev]);
    });

    return () => {
      socket.off("notification");
      socket.disconnect();
    };
  }, [token, userRole]);

  return (
    <NotificationContext.Provider
      value={{
        notifications,
        showDropdown,
        setShowDropdown,
        showAllPage,
        setShowAllPage,
        unreadCount,
        markAsRead,
        markAllAsRead,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotifications = () => useContext(NotificationContext);
